import { render, staticRenderFns } from "./VueRenderer.vue?vue&type=template&id=47845855"
import script from "./VueRenderer.vue?vue&type=script&lang=js"
export * from "./VueRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports